import React, {useEffect, useState} 	from 'react';
import ObservableService 				from '../services/ObservableService';

const PageLoader = () => {
	const [width, setWidth] = useState(0);
	const [show, setShow] = useState(false);

	useEffect(() => {
		ObservableService.subscribe('startLoadPage', start);
		ObservableService.subscribe('fullLoadPage', fullLoad);

		return () => {
			ObservableService.unsubscribe('startLoadPage', start);
			ObservableService.unsubscribe('fullLoadPage', fullLoad);
		}
	}, []);

	const start = async () => {
		await setShow(true);
		await setWidth(80);
	};

	const fullLoad = () => {
		setWidth(100);

		setTimeout(() => {
			setShow(false);
			setWidth(0);
		}, 1000);
	};

	return (
		<div style={{display: `${show ? 'block' : 'none'}`}} className="pageLoader">
			<div className="line" style={{width: `${width}%`}}>
			</div>
		</div>
	)
};

export default PageLoader;
